import { z } from 'zod';

export const passwordSchema = z
	.object({
		currentPassword: z.string().min(1, 'Senha atual é obrigatória'),
		newPassword: z
			.string()
			.min(8, 'A senha deve ter no mínimo 8 caracteres')
			.regex(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
			.regex(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
			.regex(/[0-9]/, 'A senha deve conter pelo menos um número')
			.regex(
				/[!@#$%^&*(),.?":{}|<>]/,
				'A senha deve conter pelo menos um caractere especial (!@#$%^&*...)'
			),
		confirmPassword: z.string().min(1, 'Confirme a nova senha'),
	})
	.refine((data) => data.newPassword === data.confirmPassword, {
		message: 'As senhas não coincidem',
		path: ['confirmPassword'],
	});

export type PasswordFormData = z.infer<typeof passwordSchema>;
